import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { EncrDecrServiceService } from './encr-decr-service.service';

export let isBrowserRefreshed = false;
/**
 * Secure Storage Helper service
 */
@Injectable({
  providedIn: 'root'
})

export class SecureStorage {
  private bRefreshSubscription: Subscription;
  private KeyRemoveOnRefresh: string[] = ['GetUserDetails', 'AppointmentStatusList'];
  /**
   * 'constructor'
   */
  constructor(private cryptoSer: EncrDecrServiceService, private router: Router) {
    this.bRefreshSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        isBrowserRefreshed = !router.navigated;
        if (isBrowserRefreshed) {
          this.RemoveKeysOnRefresh(this.KeyRemoveOnRefresh)
        }
      }
    });
  }

  private RemoveKeysOnRefresh(keys: string[]){
    keys.forEach(k => {
      this.removeKey(k);
    });
    this.bRefreshSubscription.unsubscribe();
  }

  /**
   * set key along with data into local storage
   */
  setKeyData(key: string, data: any) {
    this.removeKey(key);
    // generate rendom key
    let randomKey = this.cryptoSer.makesoltKey();

    key = this.cryptoSer.encryptData(randomKey, key);
    let keyValue = this.cryptoSer.encryptData(randomKey, JSON.stringify(data));
    localStorage.setItem((key + ":" + randomKey), keyValue);
  }
  /**
   * get key data from local storage
   */
  getKeyData(key: string): any {
    let matchedKey = this.findMatchingKey(key)
    if (matchedKey !== "")
      return JSON.parse(matchedKey);
    else {
      return undefined;
      // this.removeAllKey();
    }
  }
  /**
   * remove all key from local storage
   * @example
   * removeAllKey()
   */
  removeAllKey() {
    let allKeys = this.getAllBrowserKey();
    if (allKeys.length > 0) {
      allKeys.forEach(singleKey => {
        localStorage.removeItem(singleKey);
      });
    }
  }
  /**
   * remove specific key from local storage
   * @example
   * removeKey('keyname');
   */
  removeKey(keyName: string) {
    let alreadyExistKey = this.isValidKey(keyName);
    if (alreadyExistKey !== "") {
      localStorage.removeItem(alreadyExistKey);
    }
  }
  /**
   * Find all Key from browser
   */
  private getAllBrowserKey(): any[] {
    return Object.keys(localStorage).reduce(function (obj, str) {
      if (str.indexOf(':') != -1) {
        obj.push(str);
      }
      return obj
    }, []);
  }
  /**
   * find specific key from browser
   */
  private findMatchingKey(actualKey: string): any {
    let spliKey = this.isValidKey(actualKey);
    return spliKey != "" ? this.cryptoSer.decryptData(spliKey.split(':')[1], localStorage.getItem(spliKey)) : "";
  }

  /**
   * entered key is valid or not
   */
  private isValidKey(key: string): string {
    let allKeys = this.getAllBrowserKey();

    let validKey = "";
    if (allKeys.length > 0) {
      allKeys.forEach(singleKey => {

        let splitStr = singleKey.split(':');
        let descKey = this.cryptoSer.decryptData(splitStr[1], splitStr[0]);
        if (descKey.indexOf('error') !== 0) {
          if (key === descKey)
            validKey = singleKey;
        }

      });
    }
    return validKey;

  }
}
